import { canUseDOM } from 'exenv';
import { get } from 'lodash';
// import { fireActionTriggerCustomEvent } from '../events/pageEvents';

export const onPageView = (page = {}) => {
  // Note - see original concept for event history tracking example
  if (canUseDOM) {
    // window.digitalData = merge({}, window.digitalData, page.data.pageObject);
  }

  // Trigger custom event to notify Adobe Launch
  // fireActionTriggerCustomEvent('standard-page-view', {});

  // return for logging, adding to history, etc.
  return page;
};
onPageView.eventType = 'PAGE_VIEW';

export const onNavClick = (page = {}) => {
  // Note - see original concept for event history tracking example
  if (canUseDOM) {
    // Datalayer update not neccesary!
    // window.digitalData = merge({}, window.digitalData, page.data.eventObject);

    // Track as an EVENT in the data layer
    const eventInfo = get(window.digitalData, 'events', []);

    eventInfo.push({
      eventName: page.data.eventName,
      eventType: page.type,
      eventInfo: page.data.eventObject
    });
    window.digitalData.events = eventInfo;
  }

  // return for logging, adding to history, etc.
  return page;
};
onNavClick.eventType = 'NAV_CLICK';
